import TimelineMax from 'gsap/TimelineMax'
import { Power3 } from 'gsap'
import { bindInViewTimeline } from '../util/animations'

class BulletNav {
  constructor ($el) {
    this.$el = $el
    // this.buildTimelineIn = this.buildTimelineIn.bind(this)
    this.timeline = new TimelineMax({
      paused: true,
      delay: 0.2,
    })
    this.buildTimelineIn()
    bindInViewTimeline($el, this.timeline)
  }

  buildTimelineIn () {
    const $el = this.$el
    this.timeline
      .staggerFromTo(
        $el.find('li'),
        0.6,
        { scaleY: 0 },
        { scaleY: 1, ease: Power3.easeOut },
        0.2
      )
  }
}

export default BulletNav



// WEBPACK FOOTER //
// ./scripts/components/BulletNav.js